import React from "react";

import { useLocation, useNavigate, useParams } from "react-router-dom";

import * as AuthApi from 'api/auth';

import * as F from 'tsui/Form';
import PageContents from "components/PageContents";
import JoinConfirmUserEmailPage from "./JoinConfirmUserEmail";


export default function JoinPage() {
    const form = F.useForm({
        type: 'input',
    });
    const navigate = useNavigate();

    const[isJoinTrue, setIsJoinTrue] = React.useState(false)
    const[email, setEmail] = React.useState('')

    const params = useParams();
    console.log('params', params)
    const checkedInputId = params.cardId!;

    const search = useLocation().search;
    const urlParams = new URLSearchParams(search);
    // const fullscreen = Url.getBoolParam(urlParams.get('fullscreen'));
    const caller = urlParams.get('cardId');
    // const close = urlParams.get('close');
    console.log('caller', caller)

    console.log('checkedInputId', checkedInputId)



    const onSubmit = React.useCallback((evt: F.InputFormEvent) => {
        if (form.error)
            return;

        let password1 = evt.notData['password1'];
        let password2 = evt.notData['password2'];

        const email = evt.data['email']
        // setEmail(email)
        const encodeEmail = encodeURIComponent(email)
        // const verificationCode = 1234
        const url = `/join_confirm_user_email?email=${email}`

        if (password1 !== password2)
            return form.setError('Passwords don\'t match');
        evt.data['password'] = password1;

        //form.clearError(); //setError(null);
        form.setBusy();
        console.log(evt.data)

        AuthApi.join(evt.data).then((sess) => {

            form.clearBusy();
            //navigate(props.return ?? '/');
            // navigate(url);
            // setIsJoinTrue(true)
            // navigate('/sucsessJoining');
        }).catch(err => form.setError(err));
    }, []);

    return <PageContents title='Join'>

        <F.PageForm title='Join' onSubmit={onSubmit} form={form} size='md' >

            <F.InputText form={form} xs={8} id='email' label='Email' placeholder='Enter Email' autocomplete='email' required validate="email" />
            {/* <Form.InputText form={form} xs={8} id='login' label='Email' placeholder='Enter Email' autocomplete='email' required validate="email"/> //id='ligin' not working */}

            <F.InputText form={form} xs={8} id='password1' label='Enter Password' placeholder='Enter Password' type='password' autocomplete="new-password" required validate='password' data={false} />

            <F.InputText form={form} xs={8} id='password2' label='Confirm Password' placeholder='Confirm Password' type='password' autocomplete="new-password" required validate='password' data={false} />


            <F.InputGroup form={form} label='Name' />

            <F.InputText form={form} xsHalf id='firstName' label='First Name' placeholder='First Name' autocomplete='given-name' />

            <F.InputText form={form} xsHalf id='lastName' label='Last Name' placeholder='Last Name' autocomplete='family-name' />


            <F.InputGroup form={form} label='Contact' optional />
            <F.InputText form={form} xs={4} id='phoneAreaCode' label='Area Code' placeholder='Area Code' autocomplete='tel' validate='tel' />
            <F.InputText form={form} xs={8} id='phoneNumber' label='Phone' placeholder='Phone' autocomplete='tel' validate='tel' />

            <F.InputGroup form={form} label='Checking card id' />
            <F.InputText form={form} xs={8} id='checkingCardId' label='Checking Card ID' placeholder='Checking Card ID' autocomplete="given-name" value={caller!} data={false} />

            <F.SubmitButton label='Submit' size='lg' form={form} xsMax align="center" />
            <F.NavigateLink label='Already have an account? Login' href='/login' form={form} xsMax mt={2} align="center" />


        </F.PageForm>
        
        {isJoinTrue && <JoinConfirmUserEmailPage email={email} />}

    </PageContents>
}